import React from 'react';
import { FormattedMessage } from 'translations';
import builder from '../builder.js';
import Header from './Header';
import TripsContainer from '../commons/TripsContainer';
import DesktopLightbox from 'app/components/base/DesktopLightbox';
import DesktopTripCard from 'app/components/search-results/Trip/Desktop';

const messages = {
  dialogTitle: { id: 'BOOK_TRIP.MEET_AND_GREET.DIALOG_TITLE' },
  dialogSubtitle: { id: 'BOOK_TRIP.MEET_AND_GREET.DIALOG_SUBTITLE' }
};

const Dialog = (props) => {
  return (
    <DesktopLightbox
      empty
      wide
      onClickClose={props.onClose}
    >
      <Header
        title={<FormattedMessage {...messages.dialogTitle} />}
        subtitle={<FormattedMessage {...messages.dialogSubtitle} />}
        onClose={props.onClose}
      />
      <TripsContainer {...props} />
    </DesktopLightbox>
  );
};

// TODO: move to Flow types
// Dialog.propTypes = {
//   onClose: PropTypes.func
// };

export default builder({
  WrappedComponent: Dialog,
  TripComponent: DesktopTripCard
});
